const state = {
  announcements: [],
  exclusives: [],
  perks: [],
  pins: [],
  chats: [],
  campaigns: [],
  dataStreamItems: [],
  chatStreamItems: [],
  uploadProgress: 0,
};

export default state;
